var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYouTube = function SvgYouTube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.4984545,6.57652823 C24,8.41468145 24,12.25 24,12.25 C24,12.25 24,16.0851855 23.4984545,17.9236048 C23.2224545,18.9376895 22.4093182,19.7363427 21.3766364,20.0075282 C19.5050455,20.5 12,20.5 12,20.5 C12,20.5 4.49495455,20.5 2.62336364,20.0075282 C1.59081818,19.7363427 0.777545455,18.9376895 0.501545455,17.9236048 C0,16.0851855 0,12.25 0,12.25 C0,12.25 0,8.41468145 0.501545455,6.57652823 C0.777545455,5.56231048 1.59081818,4.76365726 2.62336364,4.49260484 C4.49495455,4 12,4 12,4 C12,4 19.5050455,4 21.3766364,4.49260484 C22.4093182,4.76365726 23.2224545,5.56231048 23.4984545,6.57652823 Z M9.54545455,15.7321653 L15.8181818,12.2501331 L9.54545455,8.76783468 L9.54545455,15.7321653 Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYouTube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/YouTube.4eb40bf7.svg";
export { ForwardRef as ReactComponent };